/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-07 11:19:36
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  upload: '上传',
  unUpload: '未上传',
  unDevelop: '敬请期待',
  waiting: '等待中',
  deleteTip: '确认删除安装包?',
  select: '请选择',
  finish: '已完成',
  selected: '已选择',
  selectable: '可选择',
  patchPack: '补丁包',
  wholePackage: '完整包',
  checking: '上传完成，正在检测安装包...',
  checkFail: '监测不通过，',
  detail: '详情',
  retest: '重新检测',
  delete: '删除',
  retry: '重试',
  cancel: '取消',
  uploading: '正在上传中...',
  uploadFail: '上传失败',
  config: '配置',
  currentVersion: '当前版本',
  disturbanceFreeUpgrade: '无扰升级',
  disturbanceUpgrade: '有扰升级',
});
